import React, { Component } from "react"
import OutsideClickTrigger from "../common/OutsideClickTrigger"
import config from "react-global-configuration"
import LoginLink from "../common/loginLink"
import * as endpoint from "../../constants/Endpoints"
import * as trackingHelper from "../../helpers/tracking"
import Svg from "../../../shared/_svgs/svg"

class ParkingDetailsModal extends Component {
  getPricingOptions() {
    const { carPark, result } = this.props.item
    const allProducts = this.props.allProducts
    const budgetProducts = allProducts.filter((x) => x.product.categoryName === "Budget")
    if (budgetProducts && budgetProducts.length > 0) {
      if (this.props.isParkingHighlightModalActive) {
        let options = budgetProducts.filter((p) => {
          if (p.carPark.id === carPark.id) return p
          if (p.carPark.name === "P15" && p.result.totalPrice > result.totalPrice) return p
        })
        options = options
          .map((p) => {
            return {
              id: p.product.id,
              carParkName: p.carPark.name,
              price: p.result.totalPrice,
              isSoldOut: p.product.isSoldOut,
            }
          })
          .sort((x, y) => x.price - y.price)
        return options
      } else {
        const options = budgetProducts
          .filter((p) => p.carPark.id === carPark.id)
          .map((p) => {
            return {
              id: p.product.id,
              carParkName: p.carPark.name,
              price: p.result.totalPrice,
              isSoldOut: p.product.isSoldOut,
            }
          })
          .sort((x, y) => x.price - y.price)
        return options
      }
    }
    return []
  }

  renderBudgetPricing(options) {
    const { product } = this.props.item
    return (
      <div className="modal__middle">
        <ul className="parking-lot-price-options">{options.map((option, index) => this.renderPricingOption(product, option, index))}</ul>
      </div>
    )
  }
  renderPricingOption(product, option, index) {
    const textKeys = config.get("textKeys.parkingList.detailsModal") || {}
    const wpyfSettings = config.get("textKeys.weParkYouFlySettings") || {}
    const currentProduct = product.id === option.id
    let headline = <h6></h6>
    if (Math.abs(product.maxCapacity - product.currentlyBooked) <= 25 && !product.isSoldOut) {
      headline = <h6>{textKeys.fewSpots || "Få pladser online"}</h6>
    } else if (index === 0 && !currentProduct) {
      headline = <h6>{textKeys.budgetStartPrice || "Start pris"}</h6>
    } else if (index === 1 && !currentProduct) {
      headline = <h6>{textKeys.budgetNextPrice || "Næste pris"}</h6>
    } else if (index === 2 && !currentProduct) {
      headline = (
        <h6>
          {textKeys.budgetLastPrice || "Sidste pris"} - ({option.carParkName})
        </h6>
      )
    }
    const price = this.props.priceFormatter(option.price)
    return (
      <li key={index} className={`parking-lot-price-options__item ${this.getPricingOptionClassName(product, option)}`}>
        {headline}
        <h3>
          {option.isSoldOut ? (
            <React.Fragment>
              <s>{price}</s>
              <small>
                &nbsp;
                {product.categoryName === "We Park You Fly" && wpyfSettings.weParkYouFlyIsClosed
                  ? wpyfSettings.WeParkYouFlyClosedLabel || "Lukket"
                  : textKeys.soldOut || "Udsolgt"}
              </small>
            </React.Fragment>
          ) : (
            price
          )}
        </h3>
        {currentProduct && !option.isSoldOut && (
          <button
            className="button button--small button--general"
            onClick={() =>
              this.props.handleParkingDetailsClose(this.props.handleReservation(product.id, this.props.item, this.props.handleParkingDetailsCleanup))
            }
          >
            <span className="text">{textKeys.reserveButton || "Reservér"}</span>
          </button>
        )}
      </li>
    )
  }

  getPricingOptionClassName(product, option) {
    const isSignificant = product.id === option.id
    if (product.isSoldOut) {
      return "parking-lot-price-options__item--sold-out"
    } else if (isSignificant) {
      return "parking-lot-price-options__item--significant"
    } else {
      return 'parking-lot-price-options__item"'
    }
  }

  handleConfirmClick() {
    this.upgradeProductTracking(this.props.trackingEventLabel)
    this.props.handleReservation(this.props.item.product.id, this.props.item, this.props.handleParkingDetailsCleanup, this.props.isAmendment)
  }

  handleOverrideClick() {
    this.upgradeProductTracking(this.props.trackingEventLabel)
    this.props.buttonClickOverride()
  }

  upgradeProductTracking(eventLabel) {
    // only track if modal is used in upsale
    if (this.props.upsaleTrackingData) trackingHelper.trackParkingProductUpgrade(this.props, this.props.upsaleTrackingData, eventLabel)
  }

  renderMemberProduct(soldOut) {
    const textKeys = config.get("textKeys.parkingList.detailsModal") || {}
    const textKeysMember = config.get("textKeys.parkingList.memberProductModal") || {}
    const textKeysListElement = config.get("textKeys.parkingList.listElement") || {}
    const wpyfSettings = config.get("textKeys.weParkYouFlySettings") || {}
    const { buttonTextOverride, buttonClickOverride, userAccountDetails, isAmendment = false, changeFromBooking = undefined } = this.props
    const { product, result } = this.props.item
    let hasBeenLoggedIn = false
    let hasExtras = false
    let extrasAmount = 0
    if (changeFromBooking) {
      hasExtras = changeFromBooking.booking?.items?.extras[0]?.offerLines[0]?.amount ? true : false
      if (hasExtras) {
        extrasAmount = changeFromBooking.booking.items.extras[0].offerLines[0].amount
      }
      hasBeenLoggedIn = changeFromBooking.booking.membershipNumber ? true : false
    }

    const isLoggedIn = this.props.userAccountDetails ? true : false
    const memberPricePrefix = changeFromBooking ? (result.memberPrice - (changeFromBooking.booking.price - extrasAmount) > 0 ? "+" : "") : null
    const pricePrefix = changeFromBooking ? (result.totalPrice - (changeFromBooking.booking.price - extrasAmount) > 0 ? "+" : "") : null

    if (userAccountDetails || hasBeenLoggedIn /* TODO: fix this part of the modal. */) {
      return (
        <div className={"modal--parking-product-row-modal__price-and-cta"}>
          <div>
            {isAmendment ? "" : <h6 className="headline-xxxs">{textKeysListElement.memberPrice || "Medlemspris"}</h6>}

            {isAmendment ? (
              <h3>
                {memberPricePrefix}
                {this.props.priceFormatter(result.memberPrice - (changeFromBooking.booking.price - extrasAmount))}
              </h3>
            ) : (
              <h3>{this.props.priceFormatter(result.memberPrice)}</h3>
            )}

            {result.showDriveInPrice && !isAmendment ? (
              <p className={""}>
                {textKeys.driveIn || "Drive in-pris: "} <span>{this.props.priceFormatter(result.barrierTariff)}</span>
              </p>
            ) : (
              ""
            )}
            {isLoggedIn || hasBeenLoggedIn ? (
              ""
            ) : (
              <p className="parking-product-table__sub">
                {textKeys.nonMemberPrice || "Ikke medlem"}: {pricePrefix}
                {isAmendment
                  ? this.props.priceFormatter(result.totalPrice - (changeFromBooking.booking.price - extrasAmount))
                  : this.props.priceFormatter(result.totalPrice)}
              </p>
            )}
          </div>
          {!soldOut ? (
            <button
              className="button button--small button--general"
              onClick={() => this.props.handleParkingDetailsClose(buttonClickOverride ? this.handleOverrideClick() : this.handleConfirmClick())}
            >
              <span className="text">{buttonTextOverride ? buttonTextOverride : textKeys.reserveButton || "Reservér"}</span>
            </button>
          ) : product.isSoldOut && product.categoryName === "We Park You Fly" && wpyfSettings.weParkYouFlyIsClosed ? (
            <button className="button button--small button--general is-disabled">
              <span className="text">{wpyfSettings.WeParkYouFlyClosedLabel || "Lukket"}</span>
            </button>
          ) : (
            <button className="button button--small button--general is-disabled">
              <span className="text">{textKeys.soldOut || "Udsolgt"}</span>
            </button>
          )}
        </div>
      )
    } else {
      return !soldOut ? (
        <div className={"modal--parking-product-row-modal__price-and-cta"}>
          <div>
            {isAmendment ? "" : <h6 className="headline-xxxs">{textKeysListElement.memberPrice || "Pris med CPH profil"}</h6>}

            <h3>
              {isAmendment ? memberPricePrefix : ""}
              {isAmendment
                ? this.props.priceFormatter(result.memberPrice - (changeFromBooking.booking.price - extrasAmount))
                : result.memberPrice}{" "}
              {!isAmendment ? textKeys.valuta || "DKK" : ""}{" "}
            </h3>
            <p>
              {textKeysMember.nonMemberPrice || "Ikke medlem"}:{" "}
              {isAmendment
                ? pricePrefix + this.props.priceFormatter(result.totalPrice - (changeFromBooking.booking.price - extrasAmount))
                : this.props.priceFormatter(result.totalPrice)}
              {" - "}
              <button
                className="button--text-link"
                onClick={() => this.props.handleParkingDetailsClose(buttonClickOverride ? this.handleOverrideClick() : this.handleConfirmClick())}
              >
                <span className="text">{buttonTextOverride ? buttonTextOverride : textKeys.reserveButton || "Reservér"}</span>
              </button>
            </p>
          </div>
          <LoginLink
            {...this.props}
            loginurl={endpoint.ACCOUNT_LOGIN()}
            linkClassName={"button button--small button--general"}
            spanClassName={"text"}
            linkText={textKeysMember.loginLink || "Log ind / opret"}
            trackingHandler={() => trackingHelper.trackCTALoginButtonClick("parking - search")}
          />
        </div>
      ) : (
        <React.Fragment>
          <div className={"modal--parking-product-row-modal__price-and-cta"}>
            <div>
              <h3>
                {textKeys.valuta || "DKK"} {this.props.priceFormatter(result.totalPrice, true)}
              </h3>
              {result.showDriveInPrice && !isAmendment ? (
                <p className={""}>
                  {textKeys.driveIn || "Drive in-pris: "} <span>{this.props.priceFormatter(result.barrierTariff)}</span>
                </p>
              ) : (
                ""
              )}
            </div>
            {product.categoryName === "We Park You Fly" && wpyfSettings.weParkYouFlyIsClosed ? (
              <button className="button button--small button--general is-disabled">
                <span className="text">{wpyfSettings.WeParkYouFlyClosedLabel || "Lukket"}</span>
              </button>
            ) : (
              <button className="button button--small button--general is-disabled">
                <span className="text">{textKeys.soldOut || "Udsolgt"}</span>
              </button>
            )}
          </div>
        </React.Fragment>
      )
    }
  }

  renderProduct(soldOut) {
    const textKeys = config.get("textKeys.parkingList.detailsModal") || {}
    const wpyfSettings = config.get("textKeys.weParkYouFlySettings") || {}
    const { buttonTextOverride, buttonClickOverride, isAmendment = false, changeFromBooking = undefined } = this.props
    const { product, result } = this.props.item

    let hasExtras = false
    let extrasAmount = 0
    if (changeFromBooking) {
      hasExtras = changeFromBooking.booking?.items?.extras[0]?.offerLines[0]?.amount ? true : false
      if (hasExtras) {
        extrasAmount = changeFromBooking.booking.items.extras[0].offerLines[0].amount
      }
    }
    const isSpecialProduct = product && product.dynamicFields && product.dynamicFields.isSpecialProduct
    //const memberPricePrefix = changeFromBooking ? (result.memberPrice - (changeFromBooking.booking.price - extrasAmount)) > 0 ? "+" : "" : null;
    const pricePrefix = changeFromBooking ? (result.totalPrice - (changeFromBooking.booking.price - extrasAmount) > 0 ? "+" : "") : null

    return (
      <div className={"modal--parking-product-row-modal__price-and-cta"}>
        <div>
          {isAmendment ? (
            <h3>
              {pricePrefix}
              {this.props.priceFormatter(result.totalPrice - (changeFromBooking.booking.price - extrasAmount), true)} {textKeys.valuta || "DKK"}
            </h3>
          ) : (
            <h3>
              {textKeys.valuta || "DKK"} {this.props.priceFormatter(result.totalPrice, true)}
            </h3>
          )}
          {result.showOriginalPrice && !isAmendment ? (
            <p className={"price-line-through"}>
              {textKeys.previousPrice || "Førpris:"} <span>{this.props.priceFormatter(result.originalPrice)}</span>
            </p>
          ) : result.showDriveInPrice && !isAmendment ? (
            <p className={""}>
              {textKeys.driveIn || "Drive in-pris:"} <span>{this.props.priceFormatter(result.barrierTariff)}</span>
            </p>
          ) : (
            ""
          )}
        </div>
        {!soldOut ? (
          isSpecialProduct ? (
            <button className="button button--small button--general" onClick={() => this.props.handleSpecialProductClickFromDetails()}>
              <span className="text">{textKeys.reserveButton || "Reservér"}</span>
            </button>
          ) : (
            <button
              className="button button--small button--general"
              onClick={() => this.props.handleParkingDetailsClose(buttonClickOverride ? this.handleOverrideClick() : this.handleConfirmClick())}
            >
              <span className="text">{buttonTextOverride ? buttonTextOverride : textKeys.reserveButton || "Reservér"}</span>
            </button>
          )
        ) : product.categoryName === "We Park You Fly" && wpyfSettings.weParkYouFlyIsClosed ? (
          <button className="button button--small button--general is-disabled">
            <span className="text">{wpyfSettings.WeParkYouFlyClosedLabel || "Lukket"}</span>
          </button>
        ) : (
          <button className="button button--small button--general is-disabled">
            <span className="text">{textKeys.soldOut || "Udsolgt"}</span>
          </button>
        )}
      </div>
    )
  }

  render() {
    const textKeys = config.get("textKeys.parkingList.detailsModal") || {}
    const { userAccountDetails, changeFromBooking, useNewDesign } = this.props
    const { product, carPark, ribbonText, bodySections, result, carParkUsp, carParkResume } = this.props.item
    let { usp, resume } = this.props.item
    const showMemberprice = result?.showMemberPrice
    const options = this.getPricingOptions()
    let hasBeenLoggedIn = false
    hasBeenLoggedIn = changeFromBooking?.booking?.membershipNumber ? true : false
    if (!this.props.isActive) return ""

    if (useNewDesign) {
      usp = carParkUsp
      resume = carParkResume
    }

    return (
      <React.Fragment>
        <div className={"overlay overlay--modal overlay--fixed is-active"}>
          {!this.props.isParkingProductMapModalActive ? (
            <div
              className={`modal modal--parking-product-row-modal modal-rows-padded ${showMemberprice ? "" : "modal-rows-padded"} ${
                showMemberprice && (userAccountDetails || hasBeenLoggedIn) ? "modal-rows-padded" : ""
              }`}
            >
              <OutsideClickTrigger onOutsideClick={() => this.props.handleParkingDetailsClose(this.props.handleParkingDetailsCleanup)}>
                <React.Fragment>
                  <button
                    className="button button--icon js--close-modal"
                    onClick={() => this.props.handleParkingDetailsClose(this.props.handleParkingDetailsCleanup)}
                  >
                    <span className="icon">
                      <svg className="svg-icon svg-icon--close-new">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                          &nbsp;
                        </use>
                      </svg>
                    </span>
                  </button>
                  <div className="modal__content modal__content--no-padding">
                    {/* {this.props.isParkingHighlightModalActive ? */}
                    <div className="modal__content__inner">
                      <div className="modal__top">
                        <header>
                          <div className={"modal__headline"}>
                            {useNewDesign ? (
                              <h3 className="headline-md">{carPark.name}</h3>
                            ) : (
                              <>
                                <h3 className="headline-md">{product.name}</h3>
                                <h6>{carPark.name}</h6>
                              </>
                            )}
                          </div>
                          {ribbonText ? <span className={"anchor-button anchor-button--parking"}>{ribbonText}</span> : ""}
                          <div className={"rich-text"}>
                            <span className="resume" dangerouslySetInnerHTML={{ __html: resume ? resume : product.description }}></span>
                            {usp && usp.headline ? <h6>{usp.headline}</h6> : null}
                            {usp && usp.bullets ? (
                              <ul className={usp.bullets.length < 6 ? "d-block--sm" : null}>
                                {usp.bullets.map((bullet, index) => {
                                  return (
                                    <li key={index}>
                                      <svg className="svg-icon svg-icon--checkmark">
                                        <use xlinkHref="/dist/svg/symbols.svg#svg-checkmark"></use>
                                      </svg>
                                      {bullet}
                                    </li>
                                  )
                                })}
                              </ul>
                            ) : null}

                            {/* https://cph-airport.atlassian.net/browse/PAR-984
                                                             {bodySections ? bodySections.map((section, index) => {
                                                                // sectionHeadline = section.headline;
                                                                // sectionBody = section.bodyText;
                                                                return (
                                                                    section.headline ? <div key={index}>
                                                                        <h6>{section.headline}</h6>
                                                                        <span dangerouslySetInnerHTML={{ __html: section.bodyText }} />
                                                                    </div>
                                                                        :
                                                                        <div key={index}>
                                                                            <span dangerouslySetInnerHTML={{ __html: section.bodyText }} />
                                                                        </div>
                                                                )
                                                            }) : null} */}
                          </div>

                          <button className="button button--link button--link--significant has-icon" onClick={() => this.props.handleOpenMapModal()}>
                            {useNewDesign ? <Svg iconName={"pin2"} fillColor={"none"} stroke={"#071143"} /> : <Svg iconName={"pin"} />}
                            <span className="text">{textKeys.map || "Se på kort"}</span>
                          </button>
                        </header>
                      </div>
                      {product.categoryName === "Budget" && options.length > 1 ? (
                        this.renderBudgetPricing(options)
                      ) : (
                        <div className="modal__bottom">
                          {showMemberprice ? this.renderMemberProduct(product.isSoldOut) : this.renderProduct(product.isSoldOut)}
                        </div>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              </OutsideClickTrigger>
            </div>
          ) : null}
        </div>
      </React.Fragment>
    )
  }
}

export default ParkingDetailsModal
